<template>
  <a-config-provider :locale="$i18n.locale === 'en' ? enUS : zhCN">
    <router-view v-if="haveConfig" />
  </a-config-provider>
</template>

<script>
import { ref, provide, reactive } from 'vue'
import enUS from 'ant-design-vue/es/locale/en_US'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import { ConfigProvider } from 'ant-design-vue'
import { setTheme } from './styles/theme'
import { themes } from './styles/theme/themeData'
// import instance from './api/axios'
import axios from './api/request.js'

export default {
  name: 'App',
  components: {
  },
  setup() {
    const haveConfig = ref(false)
    const bzcircleApiUrl = reactive({
      // development: 'http://192.168.110.66:9007',
      development: 'https://msp-api.easyloon.cn',
      sandbox: 'https://api.merchant.uat.easyloon.cn',
      test2: 'https://api.merchant.uat.easyloon.cn',
      fat: 'https://api.merchant.uat.easyloon.cn',
      uat: 'https://api.merchant.uat.easyloon.cn',
      production: 'https://msp-api.easyloon.cn'
    })
    const projectData = ref({
      saasMerNameZh: 'Easyloon Payment',
      saasMerNameEn: 'Easyloon Payment',
      email: 'support@Easyloon.com',
      website: 'www.easyloon.cn',
      copyRight: '@Copyright 2022 Easyloon Payment Limited. All rights reserved',
      address: 'Company registered in HongKong with Money Services Operator License number:19-12-02936',
      themeKey: 'default',
      themeColor: '#1890FF',
      electronicReceipt: true,
      openReceipt: true,
      supply: false,
      suffix: '',
      faviconList: 'bzcircle.ico',
      darkLogoList: 'login-logo-easyloon.png',
      darkLogoListWhite: 'login-logo-easyloon.png',
      lightLogoList: 'login-logo-easyloon.png',
      bgList: 'login-banner-easyloon.png',
      apiUrl: bzcircleApiUrl[process.env.NODE_ENV],
      reconReceipt: true
    })
    provide('$themeData', projectData)

    const setFavicon = (url) => {
      const link = document.querySelector("link[rel*='icon']") || document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = url
      document.getElementsByTagName('head')[0].appendChild(link)
    }

    const init = async () => {
      if (process.env.VUE_APP_SAASNAME !== 'Easyloon') {
        const baseURL = process.env.VUE_APP_SAAS_CONFIGURL

        const { data } = await instance.post(`${baseURL}/saas/getSaasMerConfig`)
        if (data.code === 'S00000') {
          projectData.value = {
            saasMerNameZh: data.data.saasMerNameZh,
            saasMerNameEn: data.data.saasMerNameEn,
            ...JSON.parse(data.data.frontJson)
          }
        } else {
          return false
        }
      }
      // setTheme(projectData.value.themeKey)
      setTheme(themes[process.env.VUE_APP_SAASNAME] ? process.env.VUE_APP_SAASNAME : 'default')
      setFavicon(projectData.value.faviconList)

      ConfigProvider.config({
        // theme: themes[projectData.value.themeKey] || themes[process.env.VUE_APP_SAASNAME] || themes['default']
        theme: themes[process.env.VUE_APP_SAASNAME] || themes['default']
      })

      axios.defaults.baseURL = projectData.value.apiUrl
      haveConfig.value = true
    }

    init()

    return {
      enUS,
      zhCN,
      haveConfig
    }
  }
}

</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
}
</style>
